'use client';
import { Check, Close } from '@mui/icons-material';
import { SwitchProps } from '@mui/material';
import { StyledSwitchButton } from './styles';

const SwitchButton = (props: SwitchProps) => {
    return (
        <StyledSwitchButton
            checked={!!props.value}
            checkedIcon={<Check />}
            icon={<Close />}
            sx={{ height: '100px' }}
            {...props}
        />
    );
};

export { SwitchButton };
